import React, { Fragment } from 'react';
import { prop } from 'ramda';

import http from 'api/http';
import { manufacturerAPI } from 'api/requests';

const getManufacturerContacts = ({ address, city, country, contactInfo, state, postalcode }) =>
  Object.entries({
    Address: [address, city, state, postalcode, country].filter(Boolean).join(', '),
    Web: contactInfo.webAddress,
    Phone: contactInfo.phone,
  })
    .filter(([, value]) => value)
    .map(([key, value], index, initArr) => (
      <Fragment key={key}>
        <b>{key}:</b> {value}{index + 1 === initArr.length ? '' : ', '}
      </Fragment>
    ));

class SummaryHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      micNumber: null,
      isMicNumberLoading: true,
    };
  }

  componentDidMount() {
    const { isBoatManufacturer } = this.props;

    if (isBoatManufacturer) {
      http
        .get(manufacturerAPI.micNumber)
        .then(response =>
          this.setState({
            isMicNumberLoading: false,
            micNumber: response.data,
          })
        )
        .catch(() => this.setState({ isMicNumberLoading: false, micNumber: null }));
    }
  }

  render() {
    const { isMicNumberLoading, micNumber } = this.state;

    const { manufacturerName, manufacturerStatus, selectedManufacturer, isBoatManufacturer } = this.props;

    const manufacturerContacts = !!selectedManufacturer && getManufacturerContacts(selectedManufacturer);

    return (
      <header className='scene__scene-header summary-scene__scene-header'>
        {`${manufacturerName} Summary`}
        {isBoatManufacturer && !isMicNumberLoading && (
          <div className='summary_mic_number'><b>{'Manufacturer\'s Identification Code: '}</b>{micNumber || '—'}</div>
        )}
        {!!prop('length', manufacturerContacts) && (
          <div className='summary_header_contact'>{manufacturerContacts}</div>
        )}
        <div className={`summary-scene__manufacturer-status ${manufacturerStatus ? 'active' : 'inactive'}`}>
          {manufacturerStatus ? 'Active' : 'Inactive'}
        </div>
      </header>
    );
  }
}

export default SummaryHeader;



// WEBPACK FOOTER //
// ./src/app/Scenes/SummaryScene/Header.jsx